export const getCookie = (name: string) => {
	const cookies = document.cookie.split(';');
	for (const cookie of cookies) {
		const [cookieName, cookieValue] = cookie.trim().split('=');
		if (cookieName === name) {
			return decodeURIComponent(cookieValue);
		}
	}
	return undefined;
};
